function initAutocompleteCity() {
    const cityAutocompleteInput = document.querySelector('.js-autocomplete-city-input');
    const zipcodeInput = document.querySelector('.js-autocomplete-city-zipcode-input');

    if (!cityAutocompleteInput || !zipcodeInput) {
        return;
    }

    const getAutocompleteResults = searchTerm => new Promise((resolve) => {
        const request = new Request(`${cityAutocompleteInput.getAttribute('data-url')}/${ searchTerm }`, {
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            method: 'get',
        });

        fetch(request)
            .then(response => response.json())
            .then(response => resolve(response));
    });

    zipcodeInput.removeEventListener('keyup', zipcodeInput.__autocompleteCityListener || (() => {}));
    zipcodeInput.__autocompleteCityListener = (e) => {
        let searchTerm = e.currentTarget.value;

        if (searchTerm.length >= 2) {
            getAutocompleteResults(searchTerm).then((response) => {
                cityAutocompleteInput.innerHTML = '';

                response.cities.forEach((city) => {
                    cityAutocompleteInput.appendChild(new Option(city.name, city.id));
                });
            });
        }
    };
    zipcodeInput.addEventListener('keyup', zipcodeInput.__autocompleteCityListener);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutocompleteCity);
} else {
    initAutocompleteCity();
}

window.initAutocompleteCity = initAutocompleteCity;
